
/* injects from baggage-loader */

'use strict';

import ProjectDonationWizardComponent from './project-donation-wizard.component';
import "./project-donation-wizard.scss";

// Child states
import ProjectDonationWizardStep0Module from './step0/project-donation-wizard.step0.module';
import ProjectDonationWizardStep1Module from './step1/project-donation-wizard.step1.module';
import ProjectDonationWizardStep2Module from './step2/project-donation-wizard.step2.module';

const ProjectDonationWizardPageModule = angular.module('project-donation-wizard-module', [
  'ui.router',

  ProjectDonationWizardStep0Module.name,
  ProjectDonationWizardStep1Module.name,
  ProjectDonationWizardStep2Module.name,

])
  .config(($stateProvider, $urlRouterProvider) => {
    'ngInject';

    $urlRouterProvider.otherwise('/');

    $stateProvider
      .state('project-donation-wizard', {
        url: '/project/{id}/donate?reward_id',
        component: 'projectDonationWizard',
        // Resolve promises into controller bindings, see component for bindings
        resolve: {
          project: function (Projects, MediaSchema, $transition$) {
            return Projects.get($transition$.params('to').id, {
              include: ['disclosure_doc']
            });
          },
          rewards: function (project, ProjectRewards) {
            let query = project.relation('pledge_rewards').query();
            return query.find();
          },
          // profile: function (Profiles) {
          //   return Profiles.fetchOwn();
          // },
          // Return a shared donation object
          donation: function (project, rewards, $stateParams) {

            let donation = {
              project_id: project.id,
              amount: project.investment_min
            };

            // Setup reward options if passed for a pledge reward
            if ($stateParams.reward_id) {

              let reward = rewards.find(r => r.id === $stateParams.reward_id);

              if ($stateParams.reward_id) {
                donation.option = 'donation_reward';
                donation.reward_id = reward.id;
                donation.amount = reward.amount;
              }

            }

            return donation;
          }
        }
      });
  })
  .component('projectDonationWizard', new ProjectDonationWizardComponent());

export default ProjectDonationWizardPageModule;



// WEBPACK FOOTER //
// ./src/app/pages/project-donation-wizard/project-donation-wizard.module.js